"use client";

import { useState } from "react";
import type { TocItem } from "./TableOfContents";

export default function MobileToc({ items }: { items: TocItem[] }) {
  const [open, setOpen] = useState(false);

  if (!items.length) return null;

  return (
    <div className="xl:hidden mb-8 rounded-xl border border-black/[0.04] bg-black/[0.01] overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-4 py-3 text-left"
      >
        <span className="text-[12px] font-medium text-black/40">
          On this page ({items.length})
        </span>
        <svg
          className={`w-4 h-4 text-black/40 transition-transform ${open ? "rotate-180" : ""}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
      </button>
      {open && (
        <nav className="px-4 pb-3 border-t border-black/[0.04]" aria-label="Table of contents">
          <ul className="space-y-0.5 pt-2">
            {items.map((item) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    setOpen(false);
                    document.getElementById(item.id)?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="block text-[13px] text-black/40 hover:text-black py-1.5 transition-colors"
                  style={{ paddingLeft: `${(item.level - 2) * 16}px` }}
                >
                  {item.text}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </div>
  );
}
